import { render } from "./ModalLoading.vue?vue&type=template&id=8f3722a2&scoped=true"
const script = {}

import "./ModalLoading.vue?vue&type=style&index=0&id=8f3722a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cpinkney\\Documents\\Dev\\GroupTrips3\\grouptrips-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f3722a2"]])

export default __exports__